// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputDigits_wrapper__ZvU1g","input":"InputDigits_input___vCep","item":"InputDigits_item__dhKiO"};